import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Maintenance from "./pages/Maintenance";
import Header from "./components/Header";
import Homepage from "./components/Homepage";
import CQPIF from "./pages/CQPIF";
// import Certification from "./pages/Certification";
// import Masterclass from "./pages/Masterclass";
import Contact from "./pages/Contact";
import ProgrammeCqp from "./pages/ProgrammeCqp";
// import ProgrammeFormation from "./pages/ProgrammeFormation";
// import ProgrammeMasterclass from "./pages/ProgrammeMasterclass";
import FAQ from "./pages/FAQ";
import LEHYVE from "./pages/LEHYVE";
import Inscription from "./pages/Inscription";
// import CertificationReformer from "./pages/CertificationReformer";
// import CertificationMat from "./pages/CertificationMat";
import ComingSoon from "./pages/ComingSoon";
import ScrollToTop from "./components/ScrollToTop";

function App() {
  return (
    <Router>
        <Header />

          <ScrollToTop />
      <Routes>
       
        <Route path="/" element={<Homepage />} />
        <Route path="/CQPIF" element={<CQPIF />} />
        <Route path="/certification" element={<ComingSoon />} />
        <Route path="/certificationReformer" element={<ComingSoon />} />
        <Route path="/certificationMat" element={<ComingSoon />} />
        <Route path="/masterclass" element={<ComingSoon />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/programme-cqp" element={<ProgrammeCqp />} />
        <Route path="/programme-formation" element={<ComingSoon />} />
        <Route path="/programme-masterclass" element={<ComingSoon />} />
        <Route path="/FAQ" element={<FAQ />} />
         <Route path="/lehyve" element={<LEHYVE />} />
         <Route path="/inscription" element={<Inscription />} />
        <Route path="*" element={<Maintenance />} /> 
      </Routes>
    </Router>
  );
}

export default App;
